import Seo from './Seo'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'

import Table from '@mui/material/Table'
import Body from '@mui/material/TableBody'
import Cell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import Head from '@mui/material/TableHead'
import Row from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

/* Functions */
import formatEuro from 'src/functions/formatEuro'

/* Components */
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Types */
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

/* Config */
import config from 'src/config'
const { versandkosten } = config

/* Timestamp from preval */
import DHL_Zohnen_Laender from './build.preval'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Auslandsversandkosten' },
]

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    container: {
      paddingTop: theme.spacing(4),
      '& a': {
        color: 'inherit',
      },
    },

    tableContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
    },

    fussnote: {
      marginBottom: theme.spacing(4),
    },

  })
)

const Auslandsversandkosten = () => {
  const classes = useStyles()
  const germanyOnly = config.deliveryCountries.length === 1 && config.deliveryCountries[0] === 'DE'
  const zone1 = Array.isArray(DHL_Zohnen_Laender?.[1]) ? DHL_Zohnen_Laender[1] : []
  const zone2 = Array.isArray(DHL_Zohnen_Laender?.[2]) ? DHL_Zohnen_Laender[2] : []
  const zone3 = Array.isArray(DHL_Zohnen_Laender?.[3]) ? DHL_Zohnen_Laender[3] : []

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      {germanyOnly ? 'Auslandsversand' : 'Auslandsversand und internationale Lieferungen'}
    </Typo>

    <Typo component='p' variant='h6' color='inherit' gutterBottom>
      {germanyOnly
        ? 'Aufgrund der Verpackungsverordnung und der hohen Lizenzkosten liefern wir derzeit ausschließlich innerhalb Deutschlands.'
        : 'Selbstverständlich beliefern wir auch unsere Kunden im Ausland. Die Versandkosten finden Sie in der folgenden Tabelle.'
      }
    </Typo>
    
    {!germanyOnly && <TableContainer component={Paper} className={classes.tableContainer}>
      <Table aria-label="Auslandsversandkosten" sx={{ '& td': { whiteSpace: 'nowrap' } }}>
        <Head>
          <Row>
            <Cell>Land</Cell>
            <Cell>Paketversand</Cell>
            <Cell>Speditionsversand</Cell>
          </Row>
        </Head>
        <Body>

          <Row>
            <Cell component='th'>
              {zone1.map(land => `${land}, `)}
            </Cell>
            <Cell>{formatEuro(versandkosten.dhlZohne1)}</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

          <Row>
            <Cell component='th'>
              {zone2.map(land => `${land}, `)}
            </Cell>
            <Cell>{formatEuro(versandkosten.dhlZohne2)}</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

          <Row>
            <Cell component='th'>
              {zone3.map(land => `${land}, `)}
            </Cell>
            <Cell>{formatEuro(versandkosten.dhlZohne3)}</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

          <Row>
            <Cell component='th'>Schweiz (netto)*</Cell>
            <Cell>50,00 €</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

          <Row>
            <Cell component='th'>Rest Europa</Cell>
            <Cell>auf Anfrage</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

          <Row>
            <Cell component='th'>Außerhalb EU	</Cell>
            <Cell>auf Anfrage</Cell>
            <Cell>auf Anfrage</Cell>
          </Row>

        </Body>
      </Table>
    </TableContainer>}

    {!germanyOnly && <Typo className={classes.fussnote}>
      *) Lieferungen in die Schweiz erfolgen ohne deutsche MwSt. 
      Der angegebene Preis ist daher ohne MwSt. 
      Die Zollgebühren und Mehrwertsteuer in der Schweiz werden vom Kunden getragen, 
      die direkt vom Zusteller kassiert werden.
    </Typo>}

    {!germanyOnly && <Typo component='h3' variant='h5' color='inherit' gutterBottom>
      Retouren
    </Typo>}

    {!germanyOnly && <Typo>
      Wenn Sie die Waren zurückgeben möchten, 
      erfolgt die Retoure außerhalb Deutschlands auf eigene Kosten.
    </Typo>}

  </Container>
}

export default Auslandsversandkosten
